export const SHOW = 'loading/SHOW';
export const ADD_PROGRESS = 'loading/ADD_PROGRESS';
export const SET_PROGRESS = 'loading/SET_PROGRESS';
export const HIDE = 'loading/HIDE';
